import Vue from "vue";

export default {
    methods: {      
        $izonayConfirm(message) {
            return Vue.swal.fire({
            title: 'İzOnay',
            text: message,
            reverseButtons: true,
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: 'Tamam',
            cancelButtonText: 'Vazgeç'
        });       
        },
        $izonayAlert(message, icon = 'info') {
            return Vue.swal.fire('İzOnay',
            message,
            icon); 
        }
    }
}